export default __webpack_public_path__ + "static/media/mynft.f1f7554f.png";